import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/img/homeimg/searchicon.svg";

const HeroFilter = () => {
  const navigate = useNavigate();
  const [listingType, setListingType] = useState("all");
  const [keyword, setKeyword] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [location, setLocation] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const selectListingType = (type) => {
    setListingType(type);
    setPropertyType("");
    setMaxPrice("");
  };

  const filterCopy = {
    all: {
      searchTitle: "Search All Properties",
      searchPlaceholder: "Buy or rent by keyword",
      lookingFor: "Property Type",
      priceTitle: "Price",
      pricePlaceholder: "Any price",
      priceOptions: [[500000, "Up to €500,000"], [1000000, "Up to €1,000,000"], [2500000, "Up to €2,500,000"], [5000000, "Up to €5,000,000"]],
    },
    buy: {
      searchTitle: "Search",
      searchPlaceholder: "Search properties for sale",
      lookingFor: "Buy Property",
      priceTitle: "Sale Price",
      pricePlaceholder: "Any sale price",
      priceOptions: [[500000, "Up to €500,000"], [1000000, "Up to €1,000,000"], [2500000, "Up to €2,500,000"], [5000000, "Up to €5,000,000"]],
    },
    rent: {
      searchTitle: "Search",
      searchPlaceholder: "Search properties for rent",
      lookingFor: "Rent Property",
      priceTitle: "Monthly Rent",
      pricePlaceholder: "Any monthly rent",
      priceOptions: [[1500, "Up to €1,500 / month"], [3000, "Up to €3,000 / month"], [5800, "Up to €5,800 / month"], [10000, "Up to €10,000 / month"]],
    },
  }[listingType];

  const handleSearch = () => {
    const target = listingType === "rent" ? "/rent" : "/buy";
    const params = new URLSearchParams();

    if (listingType === "all") params.set("listingType", "all");
    if (listingType === "all" && keyword.trim()) params.set("q", keyword.trim());
    if (propertyType) params.set("type", propertyType);
    if (location) params.set("location", location);
    if (maxPrice) params.set("maxPrice", maxPrice);

    navigate(`${target}${params.toString() ? `?${params.toString()}` : ""}`);
  };

  return (
    <section className="relative z-20 px-4 sm:px-6 lg:px-8 -mt-[40px] lg:-mt-[78px]">

      <div className="max-w-[1280px] mx-auto">

        {/* Top Tabs */}
        <div className="flex items-end overflow-x-auto">

          <button onClick={() => selectListingType("all")} className={`${listingType === "all" ? "bg-white text-black border-b-[3px] border-black" : "bg-[#0B122B] text-white"} px-6 sm:px-10 py-4 sm:py-5 text-[15px] sm:text-[18px] font-semibold rounded-tl-[18px] font-[Poppins] whitespace-nowrap`}>
            All
          </button>

          <button onClick={() => selectListingType("buy")} className={`${listingType === "buy" ? "bg-white text-black border-b-[3px] border-black" : "bg-[#0B122B] text-white"} px-6 sm:px-10 py-4 sm:py-5 text-[15px] sm:text-[18px] font-semibold font-[Poppins] whitespace-nowrap`}>
            For Sale
          </button>

          <button onClick={() => selectListingType("rent")} className={`${listingType === "rent" ? "bg-white text-black border-b-[3px] border-black" : "bg-[#0B122B] text-white"} px-6 sm:px-10 py-4 sm:py-5 text-[15px] sm:text-[18px] font-semibold rounded-tr-[18px] font-[Poppins] whitespace-nowrap`}>
            For Rent
          </button>

        </div>

        {/* Filter Box */}
        <div className="bg-white rounded-br-[22px] rounded-bl-[22px] rounded-tr-[22px] shadow-2xl overflow-hidden">

          <div className={`grid grid-cols-1 items-center md:grid-cols-2 ${listingType === "all" ? "lg:grid-cols-5" : "lg:grid-cols-4"}`}>

            {/* Search */}
            {listingType === "all" && <div className="px-6 sm:px-8 py-6 sm:py-8 border-b lg:border-b-0 lg:border-r border-gray-200">

              <h3 className="text-[20px] sm:text-[22px] font-normal mb-3 font-[Pochaevsk] text-[#0B122B]">
                {filterCopy.searchTitle}
              </h3>

              <input
                type="text"
                placeholder={filterCopy.searchPlaceholder}
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                className="outline-none text-[15px] sm:text-[16px] text-gray-500 w-full font-[Poppins]"
              />

            </div>}

            {/* Looking For */}
            <div className="px-6 sm:px-8 py-6 sm:py-8 border-b lg:border-b-0 lg:border-r border-gray-200">

              <h3 className="text-[20px] sm:text-[22px] font-normal mb-3 font-[Pochaevsk] text-[#0B122B]">
                {filterCopy.lookingFor}
              </h3>

              <select value={propertyType} onChange={(event) => setPropertyType(event.target.value)} className="outline-none text-[15px] sm:text-[16px] text-gray-500 w-full bg-transparent font-[Poppins]">

                <option value="">All types</option>
                <option value="Apartment">Apartments</option>
                <option value="Villa">Villas</option>
                {listingType !== "rent" && <option value="Office">Offices</option>}

              </select>

            </div>

            {/* Location */}
            <div className="px-6 sm:px-8 py-6 sm:py-8 border-b lg:border-b-0 lg:border-r border-gray-200">

              <h3 className="text-[20px] sm:text-[22px] font-normal mb-3 font-[Pochaevsk] text-[#0B122B]">
                Location
              </h3>

              <select value={location} onChange={(event) => setLocation(event.target.value)} className="outline-none text-[15px] sm:text-[16px] text-gray-500 w-full bg-transparent font-[Poppins]">

                <option value="">Location</option>
                <option value="Spain">Spain</option>
                <option value="Netherlands">Netherlands</option>
                <option value="Dubai">Dubai</option>

              </select>

            </div>

            {/* Price */}
            <div className="px-6 sm:px-8 py-6 sm:py-8 border-b lg:border-b-0 lg:border-r border-gray-200">

              <h3 className="text-[20px] sm:text-[22px] font-normal mb-3 font-[Pochaevsk] text-[#0B122B]">
                {filterCopy.priceTitle}
              </h3>

              <select value={maxPrice} onChange={(event) => setMaxPrice(event.target.value)} className="outline-none text-[15px] sm:text-[16px] text-gray-500 w-full bg-transparent font-[Poppins]">
                <option value="">{filterCopy.pricePlaceholder}</option>
                {filterCopy.priceOptions.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
              </select>

            </div>

            {/* Search Button */}
            <div className="px-6 py-6">

              <button type="button" onClick={handleSearch} className="w-full bg-[#0B122B] text-white rounded-2xl py-4 sm:py-5 flex items-center justify-center gap-3 text-[17px] sm:text-[20px] font-medium hover:bg-black transition font-[Poppins]">

                <img
                  src={searchIcon}
                  alt="search"
                  className="w-5 h-5"
                />

                Search

              </button>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default HeroFilter;